<div class="battery-wrapp" [ngClass]="{small: small}">
  <div class="body" [ngStyle]="{ 'background-color': levelColor }">{{ batteryLevel }}%</div>
  <div class="pin" [ngStyle]="{ 'background-color': levelColor }"></div>
</div>